<template>
	<div class="home_page">
		<header>
			<div class="itemLeft">
				<div class="menu_icon_box">
					<img class="menu_icon" src="../../../static/images/menu@2x.png" v-if="!isShowMenu"
						@click="openMenu" />
					<img class="menu_icon" src="../../../static/images/close@2x.png" v-else @click="closeMenu" />
				</div>
				<img class="logo" src="../../assets/img/logo.png" alt  />
				<span class="header-title" style="margin-left: 12px;">宠米后台管理系统</span>
			</div>
			<!-- <div class="time-item">
				<span>{{ serverTime }}</span>
			</div> -->
			<div class="user_info_box">
				<div class="user_info" @click="closeMenuHead">
					<div class="flex_center">
						<span class="role"></span>
						<span class="username" v-if="$store.state.userInfo">
							{{ $store.state.userInfo.username }}
						</span>
						<a-dropdown>
							<img class="icon" src="../../../static/images/xiala@2x.png" alt />
							<a-menu slot="overlay">
								<a-menu-item>
									<span @click="changePassword">修改密码</span>
								</a-menu-item>
								<a-menu-item>
									<span @click="exit">退出登录</span>
								</a-menu-item>
							</a-menu>
						</a-dropdown>
					</div>
				</div>
			</div>
		</header>
		<section>
			<!-- 左侧菜单 -->
		<div id="menu_demo">
		<Menu style="overflow-y: auto; overflow-x: hidden; height: 100%;" :menuList="menuList" :activeRouteName="currentLabel" :isShowMenu="isShowMenu"
				@onClick="onMenuClick" />
		</div>
			<!-- 右侧内容区 -->
			<div class="content_box">

				<!-- 顶部的标签 -->
				<div class="router_list" v-if="getLabel.length">
					<Label v-model="getLabel" :labelToName="labelToName" :current="$route.fullPath" :currentName="tabCurrentLabel" :left.sync="labelLeft"
						@click="onLabelClick" @onRemove="onLabelRemove" />
				</div>

				<div class="content_view" style="background-color: #f7f7f7;">
					<!-- ====================== 新增：面包屑 start ====================== -->
				<div style="height: 50px;display: flex;flex-direction: column;justify-content: center;border-bottom: 1px solid #eee;background-color: #fff;padding-left: 20px;" class="breadcrumb_box" v-if="breadcrumbList.length">
					<a-breadcrumb>
						<!-- <a-breadcrumb-item @click="toIndex">首页</a-breadcrumb-item> -->
						<a-breadcrumb-item v-for="(item, i) in breadcrumbList" :key="i" @click="goBread(item.name)">
							{{ item.title }}
						</a-breadcrumb-item>
					</a-breadcrumb>
				</div>
				<!-- ====================== 新增：面包屑 end ====================== -->

					<keep-alive :include="keepAliveArray">
						<router-view :key="routerKey" />
					</keep-alive>
					</keep-alive>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
	import Menu from "../../components/Menu.vue";
	import Label from "../../components/Label.vue";
	import {
		mapGetters
	} from "vuex";
	import {
		menuList
	} from "@/config/routerConfig.js";
	import {
		// getIndexTimeApi,
		logout
	} from "../../api/index";

	export default {
		name: "Home",
		data() {
			return {
				breadcrumbList: [],
				currentLabel: "",
				resultTimeData: {},
				keepAliveArray: [
					'settingGeneral'
				],
				isShowMenu: true,
				menuList,
				labelToName: {
					VIPLIST: "用户管理",
					VIPDETAIL: '用户详情',
					FACTORYMANAGE: "工厂管理",
					FACTORYDETAIL: '工厂/品牌编辑',
					FACTORYEDIT: '工厂编辑',
					BRANDEDIT: '品牌编辑',
					BRANDMANAGE: "品牌管理",
					EXECUTIONSTANDARD: "执行标准",
					LAWSREGULATIONS: "法律法规",
					TRIGGERCASE: "处罚案例",
					COMPLAINTGUIDE: "投诉指南",
					LABELSETTINGS: "标签设置",
					FCTORY_BAND_SPPLIERMANAGE: "其他标签管理",
					HOMEPAGE: "首页筛选",
					WORDMOUTHPAGE: "口碑互动",
					COMPLAINTMANAGE: "举报管理",
					SENSITIVEWORDMANAGE: "敏感词管理",
					ROLEMANAGE: "角色管理",
					ADMANAGE: "广告管理",
					SEARCHMANAGE: "搜索管理",
					OEMCONSULT: "代工咨询",
					FEEDBACK: "意见反馈",
					MSGCHANNELMNG: "留言频道管理 ",
					SERVICESCRIPTMNG: "客服话术管理 ",
					HOTLINEQRCODE: "热线/二维码管理",
					SYSMSG: "系统消息 ",
					USERLIST: "员工管理",
					ROLELIST: "员工角色",
					OPERATIONLOG: "操作日志",
				},
				labelLeft: 0,
				timerId: null,
				serverTime: null,
				zoneId: null,
				days: 0,
				hours: 0,
				minutes: 0,
				seconds: 0,
				timer: null // 存储定时器，用于清除
			};
		},
		beforeDestroy() {
			// 在组件销毁前清除定时器
			clearInterval(this.timerId);
			this.timerId = null; // 清理后置空是个好习惯
		},
		created() {
			// 暂时修改
			// if (!this.$store.state.userInfo) {
			// this.$router.push({
			// name: "Login",
			// });
			// }
		},
		watch: {
			$route: {
				handler() {
					this.getBreadcrumb();
				},
				immediate: true
			},
		},
		computed: {
			routerKey() {
			  return this.$route.name === 'FACTORYDETAIL' ? this.$route.fullPath : this.$route.name
			},
			tabCurrentLabel() {
			  if (this.$route.name === 'FACTORYDETAIL') {
			    return this.$route.params.ifFacOrBr === '1' ? 'FACTORYEDIT' : 'BRANDEDIT'
			  }
			  return this.$route.name
			},
			...mapGetters(["getLabel", "getIsLoggedIn"]),
		},
		mounted() {
			let arr = this.$store.state.userInfo.resources.split(";");
			// this.serverTime = this.updateCountdown(localStorage.getItem('serverTime'), localStorage.getItem('zoneId'))
			// let arr =
			// 	'VIPMANAGEMODULE;VIPLIST;VIPDETAIL;FACTORYMODULE;FACTORYMANAGE;BRANDMODULE;BRANDMANAGE;LAWSMODULE;EXECUTIONSTANDARD;LAWSREGULATIONS;TRIGGERCASE;COMPLAINTGUIDE;LABELMODULE;LABELSETTINGS;FCTORY_BAND_SPPLIERMANAGE;HOMEPAGE;INTERMODULE;WORDMOUTHPAGE;COMPLAINTMANAGE;SENSITIVEWORDMANAGE;ROLEMANAGE;ADMODULE;ADMANAGE;SEARCHMODULE;SEARCHMANAGE;CUSMODULE;OEMCONSULT;FEEDBACK;MSGCHANNELMNG;SERVICESCRIPTMNG;HOTLINEQRCODE;SYSMSG;SYSTEMMODULE;USERLIST;ROLELIST;OPERATIONLOG'
			// 	.split(";");
			// 暂时修改
			this.menuList = this.getPermissions(this.menuList, arr);
			this.menuList = this.menuList
			console.log(this.menuList)
			if (this.getIsLoggedIn) {
				if (localStorage.getItem("fhaccessToken")) {
					// this.getDataTime()
					this.timerId = setInterval(() => {
						// this.getDataTime()
					}, 1000)
				} else {}
			} else {}
		},
		methods: {
			getBreadcrumb() {
				const routeName = this.$route.name;
				const meta = this.$route.meta || {};

				// 规则：
				// 1. 列表页：VIPLIST → 用户管理
				// 2. 详情页：VIPDETAIL → 用户管理 > 用户详情
				// 3. 从 labelToName 取父级名称，从路由 meta 取当前名称

				let crumbs = [];

				// 父级名称（你原来的 labelToName 完全可以复用）
				const parentMap = {
					VIPLIST: "用户管理",
					VIPDETAIL: "用户管理",
					FACTORYMANAGE: "工厂管理",
					BRANDMANAGE: "品牌管理",
				};

				const parentName = parentMap[routeName];
				if (parentName) {
					crumbs.push({
						title: parentName
					});
				}

				// 当前名称（优先取路由 meta.title）
				const currentTitle = meta.title || this.labelToName[routeName] || "";
				if (currentTitle) {
					crumbs.push({
						title: currentTitle
					});
				}

				this.breadcrumbList = crumbs;
			},

			// 点击面包屑跳转
			goBread(name) {
				this.$store.commit("ADD_LABEL", name);
				this.$router.push({
					name
				});
			},
			updateCountdown(targetTimestamp, zoneId) {
				// 校验时间戳有效性
				if (!targetTimestamp || isNaN(targetTimestamp)) {
					return "";
				}
				// 转换为毫秒级时间戳并创建Date对象
				const date = new Date(targetTimestamp * 1000);
				const options = {
					year: "numeric", // 四位年份（如2025）
					month: "2-digit", // 两位月份（如04）
					day: "2-digit", // 两位日期（如15）
					hour: "2-digit", // 两位小时（如10）
					minute: "2-digit", // 两位分钟（如30）
					second: "2-digit", // 两位秒数（如17）
					timeZone: zoneId, // 指定时区
					hour12: false // 禁用12小时制（使用24小时制）
				};

				try {
					const formatter = new Intl.DateTimeFormat("zh-CN", options);
					const parts = formatter.formatToParts(date);

					// 提取各个部分
					let year, month, day, hour, minute, second;

					parts.forEach(part => {
						switch (part.type) {
							case 'year':
								year = part.value;
								break;
							case 'month':
								month = part.value;
								break;
							case 'day':
								day = part.value;
								break;
							case 'hour':
								hour = part.value;
								break;
							case 'minute':
								minute = part.value;
								break;
							case 'second':
								second = part.value;
								break;
						}
					});

					return `${year}年${month}月${day}日 ${hour}:${minute}:${second}`;
				} catch (error) {
					console.error('时间格式化错误:', error);
					return "时间格式错误";
				}
			},
			// 格式化数字为两位数
			formatNumber(num) {
				return num < 10 ? `0${num}` : num.toString()
			},
			getPermissions(menuList, powers) {
				const result = [];
				menuList.forEach((menu) => {
					if (powers.includes(menu.name)) {
						const obj = {
							title: menu.title,
							name: menu.name,
							icon: menu.icon,
						};
						obj.children = menu.children.filter((subMenu) =>
							powers.includes(subMenu.name)
						);
						result.push(obj);
					}
				});
				return result;
			},
			// 左侧的菜单点击
			onMenuClick(value) {
				// 编辑页离开保护
				if (window.__isEditingDirty && !window.__justSaved) {
					const now = Date.now()
					if (window.__lastDirtyConfirm && now - window.__lastDirtyConfirm < 3000) {
						// 3 秒内已确认过，跳过
					} else {
						const leave = window.confirm('当前编辑内容尚未保存，确定要离开吗？离开后未保存的修改将丢失')
						if (!leave) return
						window.__lastDirtyConfirm = now
					}
				}
			console.log(value, '33')
			this.$store.commit("SET_SELECTED_KEYS", [value]);
			this.$store.commit("ADD_LABEL", value);
			this.$router.push({
				name: value,
			});
		},

		// 顶部的点击
		onLabelClick(routerName) {
				if (window.__isEditingDirty && !window.__justSaved) {
					const now = Date.now()
					// 3 秒内已确认过离开，不再重复弹窗
					if (!window.__lastDirtyConfirm || now - window.__lastDirtyConfirm > 3000) {
						const leave = window.confirm('当前编辑内容尚未保存，确定要离开吗？离开后未保存的修改将丢失')
						if (!leave) return
						window.__lastDirtyConfirm = now
					}
				}
			this.currentLabel = routerName
			if (routerName === 'FACTORYEDIT' && window.__factoryEditPath) {
			  this.$router.replace(window.__factoryEditPath)
			} else if (routerName === 'BRANDEDIT' && window.__brandEditPath) {
			  this.$router.replace(window.__brandEditPath)
			} else if (typeof routerName === 'string' && routerName.startsWith('/')) {
			  this.$router.replace(routerName)
			} else {
			  this.$router.replace({ name: routerName })
			}
				if (routerName !== "welcome") {
					this.countOpenKey(routerName);
				}
			},
			countOpenKey(router) {
				// 编辑页标签跳过菜单选中逻辑
				if (typeof router === 'string' && (router.startsWith('/') || router === 'FACTORYEDIT' || router === 'BRANDEDIT')) return
				if (router === "Home") {
					this.$store.commit("SET_SELECTED_KEYS", []);
					this.$store.commit("SET_OPEN_KEYS", []);
				} else {
					const current = this.menuList
						.map((menu, mIndex) => {
							const subIndex = menu.children.findIndex(
								(sub) => sub.router === router
							);
							if (subIndex >= 0) {
								return {
									mIndex: mIndex,
									subIndex,
								};
							}
							return null; // 明确返回 null
						})
						.filter((f) => f); // 过滤掉 null 值

					// 添加检查：如果找不到匹配项，直接返回
					if (!current || current.length === 0 || !current[0]) {
						console.warn(`未找到 router: ${router} 的菜单项`);
						this.$store.commit("SET_SELECTED_KEYS", []);
						this.$store.commit("SET_OPEN_KEYS", []);
						return;
					}

					this.$store.commit("SET_OPEN_KEYS", [`sub${current[0].mIndex}`]);
					this.$store.commit("SET_SELECTED_KEYS", [
						`${current[0].mIndex};${current[0].subIndex}`,
					]);
				}
			},
			onLabelRemove(routerName) {
				if (window.__isEditingDirty && !window.__justSaved) {
					const now = Date.now()
					if (!window.__lastDirtyConfirm || now - window.__lastDirtyConfirm > 3000) {
					const leave = window.confirm('当前编辑内容尚未保存，确定要离开吗？离开后未保存的修改将丢失')
					if (!leave) {
						this.$store.commit('ADD_LABEL', routerName)
						return
					}
					window.__lastDirtyConfirm = now
					}
				}
			const index = this.getLabel.indexOf(routerName);
			this.$store.commit("REMOVE_LABEL", routerName);
				let nextRouter = "Home";
				if (this.getLabel.length) {
					nextRouter = this.getLabel[index - 1] || this.getLabel[index];
				}
				if (typeof nextRouter === 'string' && nextRouter.startsWith('/')) {
				  this.$router.push(nextRouter)
				} else {
				  this.$router.push({ name: nextRouter })
				}
				this.countOpenKey(nextRouter);
			},

			toIndex() {
				this.$store.commit("ADD_LABEL", "WELCOME");
				this.$router.push({
					name: "WELCOME",
				});
			},
			exit() {

				logout()
					.then((res) => {
						if (res.resultStatus) {
							localStorage.removeItem("accessToken");
							localStorage.removeItem("fhaccessToken");
							this.$router.push("/");
							this.$store.commit("CLEAR_VUEX");
							if (this.timerId) {
								clearInterval(this.timerId)
								this.timerId = null
							}
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {});

			},
			changePassword() {
				this.$router.push({
					name: "changePassword",
				});
			},
			openMenu() {
				let div = document.getElementById("menu_demo");
				div.style.width = "160px";
				this.isShowMenu = true;
			},
			closeMenu() {
				let div = document.getElementById("menu_demo");
				div.style.width = "0px";
				this.isShowMenu = false;
			},
			closeMenuHead() {
				if (this.isShowMenu) {
					let div = document.getElementById("menu_demo");
					div.style.width = 0;
					this.isShowMenu = false;
				}
			},
			toUserDetail(value) {
				if (value > 0) {
					this.$store.commit("ADD_LABEL", "WALLETLIST");
					this.$router.push({
						name: 'WALLETLIST',
						query: {
							status: 'SIGN',
							t: Date.now()
						}
					})
				}
			},
			toOrderDetail(value) {
				this.$store.commit("IS_LOGGE_IN", true);
				this.$store.commit("ADD_LABEL", "ORDERLIST");
				if (value == '1') {
					this.$router.push({
						name: 'ORDERLIST',
						query: {
							status: 'VERIFY',
							key: '1',
							t: Date.now()
						}
					})
				} else if (value == '2') {
					this.$router.push({
						name: 'ORDERLIST',
						query: {
							status: 'VERIFT',
							key: '2',
							t: Date.now()
						}
					})
				} else {}
			},
			toWithDetail() {
				this.$store.commit("IS_LOGGE_IN", true);
				this.$store.commit("ADD_LABEL", "WITHDRAWALLIST");
				this.$router.push({
					name: 'WITHDRAWALLIST',
					query: {
						status: 'VERIFY',
						t: Date.now()
					}
				})
			},
			getDataTime() {
				getIndexTimeApi({})
					.then((res) => {
						if (res.resultStatus) {
							this.resultTimeData = res.resultData
							localStorage.setItem("fhaccessToken", res.resultData.accessToken);
							// localStorage.setItem("serverTime", res.resultData.serverTime);
							// localStorage.setItem("zoneId", res.resultData.zoneId);
							localStorage.setItem("startDate", res.resultData.startDate);
							localStorage.setItem("endDate", res.resultData.endDate);
							this.serverTime = this.updateCountdown(res.resultData.serverTime, res.resultData.zoneId)
						} else {
							this.$message.error(res.errorMessage);
							this.resultTimeData = {};
						}
					})
					.catch((err) => {
						console.error(err);
					})
					.finally(() => {
						// this.loading = false;
					});

			}

		},
		components: {
			Menu,
			Label,
		},
	};
</script>

<style lang="less">
	@theme-color: #2CBD9C;
	@border-color: #dddddd;

	.home_page {
		width: 100%;
		height: 100vh;
		/* 关键：占满屏幕高度 */
		display: flex;
		flex-direction: column;
		overflow: hidden;
		/* 禁止页面整体滚动 */

		>header {
			width: 100%;
			height: 64px;
			flex-shrink: 0;
			/* 固定高度不被挤压 */
			border-bottom: 1px solid #cccccc;
			box-sizing: border-box;
			background: #ffffff;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.itemLeft {
				display: flex;
				align-items: center;

				.menu_icon_box {
					float: left;
					width: 48px;
					height: 28px;
					margin: 18px;
					border-right: 2px solid #f6f6f6;

					.menu_icon {
						width: 28px;
						height: 28px;
						cursor: pointer;
					}
				}

				.logo {
					cursor: pointer;
					float: left;
					width: 42px;
					height: 42px;
				}

				.name {
					float: left;
					font-size: 16px;
					line-height: 64px;
				}
			}


			.user_info_box {
				display: flex;
				justify-content: flex-end;
				align-items: center;
				height: 100%;
				box-sizing: border-box;
				position: relative;

				.notice {
					float: left;
					width: 14px;
					height: 16px;
					margin: 45px 80px 45px 110px;
				}


				.user_info {
					float: left;
					height: 64px;
					color: #ffffff;
					padding-left: 30px;

					.header_url {
						float: left;
						width: 50px;
						height: 50px;
						border-radius: 50%;
						margin-right: 20px;
					}

					>div {
						float: left;
						height: 100%;

						.username {
							line-height: 64px;
							font-size: 16px;
							color: #000000;
						}

						.role {
							line-height: 64px;
							font-size: 19px;
							color: #000000;
						}

						.icon {
							width: 10px;
							margin: 0 26px 0 11px;
						}
					}
				}
			}
		}

		#menu_demo {
			overflow: hidden;
			flex-shrink: 0;
			width: 160px;
			height: 100%;
			transition: width 0.5s;
			>nav {
				width: 160px;
				min-width: 160px;
			}

		}


		>section {
			width: 100%;
			flex: 1;
			/* 关键：自动占满剩余高度 */
			display: flex;
			overflow: hidden;

			>.content_box {
				flex: 1;
				display: flex;
				flex-direction: column;
				min-width: 0;
				/* 防止 flex 布局溢出 */
				overflow: hidden;

				>.router_list {
					height: 44px;
					flex-shrink: 0;
					/* 固定高度，不被挤压 */
					border-bottom: 1px solid #f4f4f4;
				}

				>.content_view {
					flex: 1;
					padding: 0 20px 20px;
					// margin: 20px;
					background-color: #f7f7f7 !important;
					box-sizing: border-box;
					overflow: auto;
					/* 内容过多自动出现滚动条 */

					&::-webkit-scrollbar {
						width: 5px;
						background-color: rgba(0, 0, 0, 0);
					}

					&::-webkit-scrollbar-thumb {
						// background-color: #d4d4d4;
					}
				}
			}
		}

		#retrieve_box {
			width: 100%;
			height: auto;
			background: #ffffff;
			border-radius: 5px;
			padding: 80px 25px 30px;
			box-sizing: border-box;
			position: relative;
			font-size: 16px;
			color: #333333;

			&::before {
				content: "";
				width: 6px;
				height: 30px;
				background: @theme-color;
				position: absolute;
				top: 25px;
				left: 0;
			}

			&::after {
				content: "快速检索";
				line-height: 30px;
				font-size: 22px;
				position: absolute;
				top: 25px;
				left: 25px;
			}
		}

		.ant-table-body {
			border: 1px solid @border-color;
			border-bottom: 0;

			.ant-table-thead {
				background: #e8ece9;
			}

			.ant-table-tbody {
				tr:nth-child(2n) {
					background: #fafbfe;
				}

				tr:nth-child(2n + 1) {
					background: #ffffff;
				}
			}
		}

		.flex {
			display: flex;
		}

		.flex_center {
			display: flex;
			align-items: center;
		}
	}
</style>
